// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/highlight/highlight.js#1 $
'use strict';
angular.module('tcApp')
/**
* @ngdoc filter
* @name tcApp.filter:tcHighlight
* @description
* A filter to highlight search results in a list
*/
.filter('tcHighlight', function($document, $window) {
	var map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		'\'': '&#039;'
	};

	function escapeHtml(text) {
		if (angular.isUndefined(text)) return '';
		if (!angular.isString(text)) return text;
		return text.replace(/[&<>"']/g, function(m) { return map[m]; });
	}

	function escapeRegExp(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
	}
	
	var replaceExp = '<span class="highlighted">$1</span>';
	
	return function(text, phrase, doEscapeHtml) {
		var searchExp;
		if (phrase) {
			// For non-HTML, also escape the search phrase, so special characters (&) are highlighted correctly
			if (doEscapeHtml) phrase = escapeHtml(phrase);
			searchExp = new RegExp('(' + escapeRegExp(phrase) + ')', 'gi');
		}
		if (doEscapeHtml) {
			// this is a simple case of non-Html value - just escape HTML characters and replace search phrases
			// with new <span>s
			text = escapeHtml(text);
			if (!phrase) return text;
			text = text.replace(searchExp, replaceExp);
			return text;
		}
		// If search expression is empty do nothing
		if (!phrase) return text;

		// Now for HTML we only want to do a search / replace in the text nodes. 
		// To achieve this we need to parse HTML and walk its text nodes
		var tempNode = $document[0].createElement('p');
		tempNode.innerHTML = text;
		var treeWalker = $document[0].createTreeWalker(
			tempNode, 
			$window[0].NodeFilter.SHOW_TEXT);

		// We need to store replacements in an array and then apply them because
		// TreeWalker freaks out if we try to moidify a tree it's currently walking
		var nodeReplacements = []; 

		var node;
		while ((node = treeWalker.nextNode())) {
			if (node.textContent.match(searchExp)) {
				var newContent = node.textContent.replace(searchExp, replaceExp);
				var newNode = $document[0].createElement('span');
				newNode.innerHTML = newContent;
				nodeReplacements.push({oldNode: node,newNode: newNode});
			}
		}
		for (var i = 0; i < nodeReplacements.length; i++) {
			nodeReplacements[i].oldNode.parentNode.replaceChild(nodeReplacements[i].newNode, nodeReplacements[i].oldNode);
		}
		text = tempNode.innerHTML;
		return text;
	};
});
